import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10.25 13.25H4.75V11.25C4.75 10.6977 5.19772 10.25 5.75 10.25H9.25C9.80228 10.25 10.25 10.6977 10.25 11.25V13.25Z" fill="currentColor" />
		<Path d="M13.75 14L13.75 11.25C13.75 10.6977 14.1977 10.25 14.75 10.25H18.25C18.8023 10.25 19.25 10.6977 19.25 11.25V14" />
	</SVG>
);
